import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('balance_transaction')
}

const getters = {
  ...restful.getters('balance_transaction')
}

const actions = {
  ...restful.actions('balance_transactions'),
}

const mutations = {
  ...restful.mutations('balance_transaction')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
